module.exports = __webpack_public_path__ + "media/images/social_briefly24-1859ad7a82715943b6b68ce6e5c8c051.png";